<div if.bind="account.userLoginConfigured && (account.isAuthenticated || !admin.isAdmin)" class="account-menu">
  <button
    if.bind="!account.isAuthenticated"
    class="account-btn account-btn--signin"
    click.trigger="account.signIn()"
    disabled.bind="calendar.loading">Sign in</button>
  <template if.bind="account.isAuthenticated">
    <button
      class="account-btn ${account.accountMenuOpen ? 'active' : ''}"
      click.trigger="account.toggleAccountMenu()"
      aria-label="Account menu"
      aria-haspopup="true"
      aria-expanded.bind="account.accountMenuOpen">
      <span class="account-btn__avatar">${(account.userDisplayName || account.userEmail || '?').charAt(0).toUpperCase()}</span>
    </button>
    <div if.bind="account.accountMenuOpen" class="account-menu__backdrop" click.trigger="account.closeAccountMenu()"></div>
    <div if.bind="account.accountMenuOpen" class="account-menu__dropdown">
      <div class="account-menu__identity">
        <span class="account-menu__name">${account.userDisplayName || account.userEmail}</span>
        <span class="account-menu__tier">${account.userTier} plan</span>
      </div>
      <button class="account-menu__item" click.trigger="account.openProfile()">
        <span class="account-menu__icon"><span class="icon icon--person" aria-hidden="true"></span></span>
        <span>Profile</span>
      </button>
      <button class="account-menu__item" click.trigger="account.signOut()">
        <span class="account-menu__icon"><span class="icon icon--signout" aria-hidden="true"></span></span>
        <span>Sign out</span>
      </button>
    </div>
  </template>
</div>
